module.exports = __webpack_public_path__ + "static/media/instagram.9c0a3e22.svg";